import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../api';

export default function Login() {
  const nav = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('admin');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { username, password });
      localStorage.setItem('token', data.token);
      if (data.user) localStorage.setItem('user', JSON.stringify(data.user));
      toast.success('Вход выполнен');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Неверный логин/пароль');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="rm-login">
      <form className="rm-login-card" onSubmit={submit}>
        <div className="rm-logo" style={{ marginBottom: 14 }}>A</div>
        <h1>Apex Panel</h1>
        <p>Панель управления логами и билдами</p>
        <div className="rm-field" style={{ marginBottom: 12 }}>
          <label>Логин</label>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </div>
        <div className="rm-field" style={{ marginBottom: 16 }}>
          <label>Пароль</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button className="rm-btn primary" style={{ width: '100%', justifyContent: 'center', padding: 12 }} disabled={loading}>
          {loading ? 'Вход…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
